export default function InfoEmbedCanva() {
  const url = 'https://www.canva.com/design/DAHIq5qhDfI/K7qFphrvnzowLUUGztxU6A/view?embed'
  return (
    <div
      className="mt-2 border rounded alert alert-warning w-100"
      role="alert"
    >
      <h6>
        <i className="fas fa-info-circle mr-1" />
        Mendapatkan link embed dari Canva
      </h6>
      <ol className="mb-0 pl-4">
        <li>
          Buka Canva, pilih file yang ingin dibagikan
        </li>
        <li>
          Klik tombol <strong>Bagikan</strong>/
          <strong>Share</strong>
        </li>
        <li>
          Pilih <strong>Embed</strong>
        </li>
        <li>
          Salin/copy link
        </li>
        <li>
          Tambahkan <strong>?embed</strong> di akhir link
        </li>
        <li>
          Contoh: {' '}
          <a href={url} target="_blank" rel="noopener noreferrer" className="text-break">
            {url}
          </a>
        </li>
      </ol>
    </div >
  )
}